import React from "react";
import "./StockChart.scss";
import {MDBBox} from "mdbreact";
import Chart from 'react-apexcharts'
import dateFormat from "dateformat";
import {numberFormat} from "../util";
import moment from 'moment';


class StockChart extends React.Component {

	render() {
		console.log("calling")
		const {xaxis, yaxis, color, sparkline, graph_filter,graph_loading} = this.props;


		let series = [{
			name: 'series1',
			data: yaxis
		}];
		let options = {
			colors: [color],
			chart: {
				height: sparkline ? 67 : 170,
				width: "100%",
				type: 'area',
				toolbar: {
					show: false,
				},
				events: {
					mouseMove: function (event, chartContext, config) {

						var tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
						var pointsArray = config.globals.pointsArray;
						var seriesIndex = config.seriesIndex;
						var dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;
						if (seriesIndex !== -1) {

							var position = pointsArray[seriesIndex][dataPointIndex];
							tooltip.style.top = 0 + 'px';
							tooltip.style.left = (position[0]+30)  + 'px';
							if (sparkline) {
								tooltip.style.display = "none"
							}
						}
					}
				},
				sparkline: {
					enabled: !!(sparkline && sparkline === true)
				},
			},
			noData: {
				text: graph_loading === true ? 'Loading...':sparkline === true?'':'No Data'
			},
			grid: {
				show: false,
				padding: {
					left: sparkline && sparkline === true ? 0 : 20,
					right:  sparkline && sparkline === true ? 0 : 20,
					bottom: 0,
					top: 0
				},

			},
			dataLabels: {
				enabled: false,
			},
			markers: {
				colors: ['#F1C144'],
				strokeColors: '#fff',
				shape: "circle",
				hover: {
					size: [8]
				}

			},
			stroke: {
				curve: this.props.curve,
				width: 1.5,
			},
			xaxis: {
				categories: xaxis,
				type: "datetime",

				crosshairs: {
					show: true,
					width: 20,
					position: 'back',
					opacity: 1,
					stroke: {
						width: 0,
						dashArray: 0,
					},
					fill: {
						type: 'solid',
						color: '#FFFFFF',
						gradient: {
							colorFrom: '#FFFFFF',
							colorTo: '#FFFFFF',
							stops: [0, 100],
							opacityFrom: 0.73,
							opacityTo: 0,
						},
					},
				},
				// showDuplicates: false,
				tickAmount: 5,
				labels: {
					rotate: 0,

					showDuplicates: false,
					formatter: function(val, timestamp) {
						// console.log(val,timestamp);
						return graph_filter === "1day" ?
							moment(val).format("h:mm a"):
							moment(val).format("DD/MM");
					},
					// format: graph_filter === "1day"?'HH:mm TT':'dd/MM',
					datetimeUTC: true,
					style: {
						colors: ["#717178"],
						fontSize: '10px',
						fontFamily: 'Inter, serif',
						fontWeight: 400,
						cssClass: 'apexcharts-xaxis-label',
					},

				},
				tooltip: {
					enabled: false,
					style: {
						height: "58px",
						width: "124px"
					},

				},
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false,
				},
				position: 'bottom',

			},
			yaxis: {
				show: true
			},
			tooltip: {
				enabled: !(sparkline && sparkline === true),
				custom: function ({series, seriesIndex, dataPointIndex, w}) {
					let now = new Date(xaxis[dataPointIndex]);
					// let formated_date = dateFormat(now, "h:MM TT, dS mmmm");
					let formated_date = moment(now).format("h:mm A Do MMM")
					return (
						'<div class="custom-tooltip-box">' +
						'<p class="tooltip-stock-price">' +
						numberFormat(series[seriesIndex][dataPointIndex]) +
						"</p>" +
						'<p class="tooltip-stock-date">' +
						formated_date +
						"</p>" +
						"</div>"
					);
				},
			},
			fill: {
				type: "gradient",
				gradient: {
					shadeIntensity: 1,
					opacityFrom: 0.5,
					opacityTo: 0.2,
					// stops: [0, 20, 100]
				}
			},

		};
		return (
			<MDBBox className={"stock-chart-component"}>
				<div id="chart"  >
					<Chart options={options} series={series} type="area" height={sparkline ? 67 : 170}
					       width={"100%"}/>
				</div>
			</MDBBox>
		);
	}
}

export default StockChart;
